import { VanillaMQ } from '../plugins/workshop/ws-media-query.js-v1.0.1/dist/js/index.min';
import { Accordion } from "../plugins/workshop/ws-accordion.js-v1.0.0/Accordion.js";
import { VanillaSlideToggle, VanillaFadeToggle } from '../plugins/workshop/ws-display-toggle.js-v1.0.1/src/index.js';

export default (function () {

	(function () {
		let footerLogin = document.querySelector('#footer-login');
		if (footerLogin && typeof drupalSettings != "undefined" && drupalSettings.hasOwnProperty('path')) {
			let footerLoginURL = footerLogin.href,
				currentPath = drupalSettings.path.currentPath,
				footerLoginDestination = footerLoginURL.concat(currentPath);
			footerLogin.href = footerLoginDestination;
		}
	})();

	(function () {
		let dataTables = document.querySelectorAll('table.data-display');

		dataTables.forEach(function (value) {
			let tableWrap = document.createElement('div');
			tableWrap.classList.add('data-display-wrap');
			value.parentNode.insertBefore(tableWrap, value);
			tableWrap.appendChild(value);
		});

		/* open wysiwyg external links in new window */
		let extLinks = document.querySelectorAll('a.btn--external_link, a.btn--external_span_link_btn--inline');
		let srSpan = document.createElement('span'),
		srText = document.createTextNode(' opens a new window');
		srSpan.classList.add('sr-only');
		srSpan.appendChild(srText);
		extLinks.forEach(function (value) {
			value.setAttribute('target', '_blank');
			value.setAttribute('rel', 'noopener');
			value.appendChild(srSpan);
		});
	})();

	(function () {

		var mobileFade;
		var mobileButton = document.getElementById("main_menu_mobile");

		window.addEventListener("DOMContentLoaded", function () {
			mobileFade = new VanillaFadeToggle();
		});

		document.addEventListener("DOMContentLoaded", function () {
			mobileMenuOpen(this);
		});

		//add mobile_menu--open class to html tag
		function mobileMenuOpen(target) {

			var classes = {
				headerMobileActive: 'header--mobile_active',
				mobileOpen: "mobile_menu--open",
				mobileButtonActive: "header__mobile_button--active"
			};
			var ids = {
				mainMenuMobile: "main_menu_mobile",
				mainMenuNav: 'main_menu_nav',
			}

			var entity = {
				header: document.querySelector('.header'),
				mainMenuNav: document.getElementById(ids.mainMenuNav),
				mobileButton: document.getElementById(ids.mainMenuMobile),
			}

			function mq(x) {

				if (x.matches) {
					entity.mobileButton.removeEventListener("click", mqClick, false);

					if (entity.header.classList.contains(classes.headerMobileActive)) {
						entity.header.classList.remove(classes.headerMobileActive);
					}

					if (document.documentElement.classList.contains(classes.mobileOpen)) {
						document.documentElement.classList.remove(classes.mobileOpen);
					}

					entity.mainMenuNav.removeAttribute('style');
				} else {
					entity.mobileButton.addEventListener("click", mqClick, false);
				}
			}

			function mqClick(){
				// add/remove active class to header
				if (!entity.header.classList.contains(classes.headerMobileActive)) {
					entity.header.classList.add(classes.headerMobileActive);
				} else {
					entity.header.classList.remove(classes.headerMobileActive);
				}

				// add/remove active class to html tag
				if (!document.documentElement.classList.contains(classes.mobileOpen)) {
					document.documentElement.classList.add(classes.mobileOpen);
					mobileFade.fadeIn(entity.mainMenuNav);
				} else {
					document.documentElement.classList.remove(classes.mobileOpen);
					mobileFade.fadeOut(entity.mainMenuNav);
				}
			}

			var x = window.matchMedia("all and (min-width: 1300px)");
			mq(x) // Call listener function at run time
			x.addListener(mq) // Attach listener function on state changes
		}
	})();

	//header, sticky header and main container top margin
	//used: conditionally, when the admin adds more than one image to the header
	(function () {

		window.addEventListener("DOMContentLoaded", setMainTopMargin);
		window.addEventListener("resize", setMainTopMargin);

		function setMainTopMargin() {

			var header = document.querySelector(".internal .header");
			if (header !== null) {
				var headerLogoAndMobile = header.querySelector(".header__logo_and_mobile");
				var headerInner = header.querySelector(".header__inner");
				var mobileButton = header.querySelector(".header__mobile_button");
				var main = document.querySelector("main");

				// main.style.marginTop = headerInner.offsetHeight + "px";
			}
		}
	})();

	(function () {
		window.addEventListener("DOMContentLoaded", function () {
			if (window.scrollY > 200) {
				document.querySelector(".header").classList.add("header--not_top");
			} else {
				document.querySelector(".header").classList.remove("header--not_top");
			}
		});

		var lastScrollTop = 0;

		//add sticky class when the user scrolls down a ways
		window.addEventListener("scroll", function () {

			var st = window.scrollY;
			if (window.scrollY > 90) {
				document.querySelector(".header").classList.add("header--not_top");
			} else {
				document.querySelector(".header").classList.remove("header--not_top");
			}

			if (window.scrollY > 300) {
				document.querySelector(".header").classList.add("header--sticky");
			} else {
				document.querySelector(".header").classList.remove("header--sticky");
			}


			if (window.scrollY > 600) {
				// on downscroll
				if (st > lastScrollTop) {
					if (st > lastScrollTop + 10) {
						document.querySelector(".header").classList.remove("header--visible");
					}
				}
				// on upscroll
				else {
					if (!document.querySelector(".header").classList.contains("header--visible")) {
						document.querySelector(".header").classList.add("header--visible");
					}
				}
			} else {
				document.querySelector(".header").classList.remove("header--visible");
			}
			lastScrollTop = st; // For Mobile or negative scrolling
		});
	})();

	//CHAIN ANIMATE ON SCROLL
	//used: listing slider panel, listing panel
	document.addEventListener('DOMContentLoaded', function () {
		function chainAOS() {

			var chainAOS = document.querySelectorAll(".chainAOS");

			if (chainAOS !== null) {

				for (var i = 0; i < chainAOS.length; i++) {
					var chainAOSChildren = chainAOS[i].children;
					var delay;

					for (var j = 0; j < chainAOSChildren.length; j++) {
						delay = j * 150;
						chainAOSChildren[j].setAttribute("data-aos-delay", delay);
						if (delay >= 1) {
							delay = 0;
						}
					}
				}
			}
		}
		chainAOS();
	});

	// icon hover
	(function () {
		let targetListings = document.querySelectorAll('.icon_listing');
		let toggle = [];
		let index;

		targetListings.forEach(function (targ, index) {

			toggle[index] = new VanillaSlideToggle();

			let eventListenerSlide = {
				slideDown: function () {
					let $this = this;
					toggle[index].slideDown(this.querySelector('.icon_listing__hidden'));
				},
				slideUp: function () {
					let $this = this;
					toggle[index].slideUp(this.querySelector('.icon_listing__hidden'));
				}
				
			}

			let iconSliderMQ = new VanillaMQ({
				mediaQuery: "all and (min-width: 960px)",
				matches: function () {
					targ.addEventListener('mouseenter', eventListenerSlide.slideDown);
					targ.addEventListener('mouseenter', function() {
						document.addEventListener('keyup', function(e) {
							if (e.key == 'Escape') {
								targ.dispatchEvent(new FocusEvent('focusout'));
							}
						});
					});
					targ.addEventListener('mouseleave', eventListenerSlide.slideUp);
					targ.addEventListener('focusin', eventListenerSlide.slideDown);
					targ.addEventListener('focusout', eventListenerSlide.slideUp);
				},
				unmatches: function () {
					targ.removeEventListener('mouseenter', eventListenerSlide.slideDown);
					targ.removeEventListener('mouseenter', function() {
						document.addEventListener('keyup', function(e) {
							if (e.key == 'Escape') {
								targ.dispatchEvent(new FocusEvent('focusout'));
							}
						});
					});
					targ.removeEventListener('mouseleave', eventListenerSlide.slideUp);
					targ.removeEventListener('focusin', eventListenerSlide.slideDown);
					targ.removeEventListener('focusout', eventListenerSlide.slideUp);
					targ.querySelector('.icon_listing__hidden').style.display = null;
				}
			});
		});
	})();

	// HEADER SEARCH DROPDOWN
	(function () {
		try {

			let searchForms = document.querySelectorAll('.header__appendix .search');
			let searchFadeToggle = new VanillaFadeToggle();

			searchForms.forEach(function(searchForm) {

				let searchMG = new VanillaMQ({
					mediaQuery: "all and (min-width: 1100px)",
					matches: function () {
						searchForm.querySelector('button').addEventListener('click', searchDropdownButtonClick);
					},
					unmatches: function () {
						searchForm.querySelector('button').removeEventListener('click', searchDropdownButtonClick);
					}
				});

				function searchDropdownButtonClick() {
					searchFadeToggle.fadeToggle(this.parentElement.querySelector(".search-block-form"));
				}
			});

		} catch(err) {
			console.warn("Something's taken terrible, terrible damage.");
		}
	})();

	document.addEventListener('DOMContentLoaded', function () {
		var faq;
		faq = new Accordion();
	});

	// WA - Pause on Videos (placed here due to header-video.js not loaded)

	let playPauseBt = document.querySelector('#hero-video-play-pause');
	if (playPauseBt) {
		playPauseBt.onclick = function() {
			if (this.classList.contains('hero-video-pause')) {
				document.querySelector("#hero-video").pause();
				this.setAttribute('aria-label', 'play video');
				this.classList.add('hero-video-play');
				this.classList.remove('hero-video-pause');
			} else if (this.classList.contains('hero-video-play')) {
				document.querySelector("#hero-video").play();
				this.setAttribute('aria-label','pause video');
				this.classList.add('hero-video-pause');
				this.classList.remove('hero-video-play');
			}
		}
	}

	// WA - Keyboard accessible accordions
	let waAccordions = Array.from(document.querySelectorAll('.js-accordion__header'));
	waAccordions.forEach(function(acc) {
		acc.addEventListener('keyup', (key) => {
			if (key.code == 'Enter' || key.code == 'Space') {
				acc.click();
			}
		});
	});
	// WA - Tabs with Keyboard
	let tabGroups = Array.from(document.querySelectorAll(".js-tabs__tabs-container"));
	setTimeout(() => {
		for (var i=0; i< tabGroups.length; i++) {
			tabGroups[i].setAttribute('role', 'tablist');
			var tab = Array.from(tabGroups[i].querySelectorAll('.js-tabs__tab'));
			for (var j=0; j<tab.length; j++){
				tab[j].setAttribute('role', 'tab');
				tab[j].addEventListener('keyup', (key) => {
					tabController(key);
				});
				if (j == 0) {
					tab[j].setAttribute('aria-selected', 'true');
					tab[j].setAttribute('tabindex', '0');
				} else {
					tab[j].setAttribute('aria-selected', 'false');
					tab[j].setAttribute('tabindex', '-1');
					
				}
			}
		}
	}, 1000);
	
	function tabController(key) {
		var target = key.target;
		var parent = key.target.parentElement;
		var localTabGroup = Array.from(parent.querySelectorAll('.js-tabs__tab'));
		var ltglength = parseInt(localTabGroup.length - 1);
		var code = key.code;
		var tabsArrIndex = parseInt(localTabGroup.findIndex(element => element.isEqualNode(target)));
		switch (code) {
			case 'Enter':
				selectThis(target);
				break;
			case 'Space':
				selectThis(target);
				break;
			case 'ArrowLeft':
				switchTab('left');
				break;
			case 'ArrowRight':
				switchTab('right');
				break;
			case 'Home':
				window.preventDefault();
				switchTab('first');
				break;
			case 'End':
				window.preventDefault();
				switchTab('last');
				break;
			default: 
				break;
		}
		function switchTab(param) {
			switch (param) {
				case 'left':
					console.log(localTabGroup[ltglength]);
					if (tabsArrIndex == 0) {
						selectThis(localTabGroup[ltglength]);
					} else {
						selectThis(localTabGroup[(tabsArrIndex - 1)]);
					}
					break;
				case 'right':
					if (tabsArrIndex == ltglength) {
						selectThis(localTabGroup[0]);
					} else {
						selectThis(localTabGroup[(tabsArrIndex + 1)]);
					}
					break;
				case 'first':
					selectThis(localTabGroup[0]);
					break;
				case 'last':
					selectThis(localTabGroup[ltglength]);
					break;
				default:
					break;
			}
		}
		function selectThis(element) {
			element.click();
			element.focus();
			localTabGroup.forEach(function(currentTab){ 
				currentTab.setAttribute('tabindex', '-1');
				currentTab.setAttribute('aria-selected', 'false');
			});
			element.setAttribute('tabindex','0');
			element.setAttribute('aria-selected', 'true');

		}
	}

	// WA - Override whatever is causing aria-live to always populate in main.min.js on live regions
	setTimeout(() => {
		var liveTabs = Array.from(document.querySelectorAll('.tns-liveregion'));
		liveTabs.forEach(function(currentLive) {
			currentLive.removeAttribute('aria-live');
		})
	}, 1000);
	
	// WA - Force labels on Grantees form filters
	setTimeout(() => {
		let granteeFilters = Array.from(document.querySelectorAll('#views-exposed-form-grantees-search-page-1 .js-form-item'));
		granteeFilters.forEach(function(filter){
			let filterLabel = filter.querySelector('label');
			let filterLabelRef = filterLabel.innerHTML;
			if (filter.querySelector('.choices')) {
				let filterFormField = filter.querySelector('.choices');
				filterFormField.setAttribute('aria-label', filterLabelRef);
			}
		});
	}, 1000);


})();
